import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Form } from 'src/app/services/forms/form';
import { PpstbService } from '../../ppstb.service';

@Component({
  selector: 'ppstb-main-s7',
  templateUrl: './ppstb-main-s7.component.html',
  styleUrls: ['./ppstb-main-s7.component.scss']
})
export class PpstbMainS7Component {
  @Input() form?: Form | null;
  @Input() disabled!: boolean;
  @Input() service?: PpstbService;
}
